import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { MATCH_FEED_PREVIEW, type MatchFeedPreviewCopy } from './matchFeedPreviewCopy';

export function useMatchFeedPreviewCopy(): MatchFeedPreviewCopy {
  const { t, i18n } = useTranslation();

  return useMemo(() => {
    const entries = (Object.keys(MATCH_FEED_PREVIEW) as (keyof typeof MATCH_FEED_PREVIEW)[]).map((key) => [
      key,
      t(`home.matchFeedPreview.${key}`, { defaultValue: MATCH_FEED_PREVIEW[key] }),
    ]);
    return Object.fromEntries(entries) as MatchFeedPreviewCopy;
  }, [t, i18n.language]);
}
